module.exports = __webpack_public_path__ + "img/card5.f403e8f8.png";